export const getClickStreamEvent = {
  cashier_homepage_all_methods_unavailable_view: (unavailablePayGroup: string[]) => ({
    schema: 'iglu:com.psp/cashier_homepage_all_methods_unavailable_view/jsonschema/1-0-0',
    data: {
      unavailable_pay_group: unavailablePayGroup,
    },
  }),
  cashier_homepage_cancel_withdrawal_click: {
    schema: 'iglu:com.psp/cashier_homepage_cancel_withdrawal_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_homepage_cancel_withdrawal_close_click: {
    schema: 'iglu:com.psp/cashier_homepage_cancel_withdrawal_close_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_homepage_close_click: {
    schema: 'iglu:com.psp/cashier_homepage_close_click/jsonschema/2-0-0',
    data: {
      is_cashier_homepage_close_click: true,
    },
  },
  cashier_homepage_method_tile_click: (isPreselected: boolean) => ({
    schema: 'iglu:com.psp/cashier_homepage_method_tile_click/jsonschema/1-0-0',
    data: {
      is_preselected: isPreselected,
    },
  }),
  cashier_homepage_method_filter_button_click: {
    schema: 'iglu:com.psp/cashier_homepage_method_filter_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_homepage_open: ({
    unavailablePayGroups,
    availablePayGroups,
    preselectedPayGroup,
  }: {
    unavailablePayGroups: string[] | null;
    availablePayGroups: string[] | null;
    preselectedPayGroup: string;
  }) => ({
    schema: 'iglu:com.psp/cashier_homepage_open/jsonschema/2-0-0',
    data: {
      unavailable_pay_group: unavailablePayGroups,
      available_pay_group: availablePayGroups,
      preselected_pay_group: preselectedPayGroup,
    },
  }),

  context_cashier: (method: string, sessionId: string) => ({
    schema: 'iglu:com.psp/context_cashier/jsonschema/2-0-0',
    data: {
      session_id: sessionId,
      session_type: method,
    },
  }),
  cashier_homepage_popup_cancel_withdrawal_confirm_button_click: {
    schema: 'iglu:com.psp/cashier_homepage_popup_cancel_withdrawal_confirm_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_homepage_popup_cancel_withdrawal_not_confirm_button_click: {
    schema: 'iglu:com.psp/cashier_homepage_popup_cancel_withdrawal_not_confirm_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_infoblock_click: (action: string) => ({
    schema: 'iglu:com.psp/cashier_method_infoblock_click/jsonschema/1-0-0',
    data: {
      infoblock_action: action,
    },
  }),
  cashier_method_back_icon_click: {
    schema: 'iglu:com.psp/cashier_method_back_icon_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_change_button_click: {
    schema: 'iglu:com.psp/cashier_method_change_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_recommended_click: {
    schema: 'iglu:com.psp/cashier_method_recommended_click/jsonschema/1-0-0',
    data: {},
  },
  cashier_method_open: {
    schema: 'iglu:com.psp/cashier_method_open/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_predefined_amount_button_click: (index: number, currency: string, amount: number) => ({
    schema: 'iglu:com.psp/cashier_method_predefined_amount_button_click/jsonschema/2-0-0',
    data: {
      amount_button_index: index,
      currency,
      amount,
    },
  }),
  cashier_method_hint_click: {
    schema: 'iglu:com.psp/cashier_method_hint_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_continue_button_click: {
    schema: 'iglu:com.psp/cashier_method_continue_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_save_card_checkbox_click: (value: boolean) => ({
    schema: 'iglu:com.psp/cashier_method_save_card_checkbox_click/jsonschema/1-0-0',
    data: {
      card_saved: value,
    },
  }),
  cashier_method_submit_button_click: {
    schema: 'iglu:com.psp/cashier_method_submit_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },

  cashier_result_page_view: (
    status: string,
    declineReason: string | null = null,
    declineCode: string | null = null,
  ) => ({
    schema: 'iglu:com.psp/cashier_result_page_view/jsonschema/1-0-0',
    data: {
      order_result_status: status,
      decline_code: declineCode,
      decline_reason: declineReason,
    },
  }),
  cashier_result_page_intogame_button_click: (destination: string) => ({
    schema: 'iglu:com.psp/cashier_result_page_intogame_button_click/jsonschema/1-0-0',
    data: {
      order_result_status: 'success',
      destination_page: destination,
    },
  }),

  cashier_result_page_retry_button_click: (declineReason: string, declineCode: string | null = null) => ({
    schema: 'iglu:com.psp/cashier_result_page_retry_button_click/jsonschema/1-0-0',
    data: {
      order_result_status: 'decline',
      decline_reason: declineReason,
      decline_code: declineCode,
    },
  }),
  cashier_result_page_change_method_tile_click: {
    schema: 'iglu:com.psp/cashier_result_page_change_method_tile_click/jsonschema/1-0-0',
    data: {
      order_result_status: 'decline',
    },
  },
  cashier_result_page_all_methods_button_click: {
    schema: 'iglu:com.psp/cashier_result_page_all_methods_button_click/jsonschema/1-0-0',
    data: {
      order_result_status: 'decline',
    },
  },

  cashier_result_page_close_icon_click: (
    status: string,
    declineReason: string | null = null,
    declineCode: string | null = null,
  ) => ({
    schema: 'iglu:com.psp/cashier_result_page_close_icon_click/jsonschema/1-0-0',
    data: {
      order_result_status: status,
      decline_reason: declineReason,
      decline_code: declineCode,
    },
  }),
  cashier_method_bonus_banner_view: {
    schema: 'iglu:com.psp/cashier_method_bonus_banner_view/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_homepage_no_methods_view: {
    schema: 'iglu:com.psp/cashier_homepage_no_methods_view/jsonschema/1-0-0',
    data: {},
  },
  cashier_payout_entry_page_view: {
    schema: 'iglu:com.psp/cashier_payout_entry_page_view/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_payout_account_select_field_click: {
    schema: 'iglu:com.psp/cashier_payout_account_select_field_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_payout_new_account_add_button_click: {
    schema: 'iglu:com.psp/cashier_payout_new_account_add_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_payout_account_delete_icon_click: {
    schema: 'iglu:com.psp/cashier_payout_account_delete_icon_click/jsonschema/1-0-0',
    data: {},
  },
  cashier_payout_account_delete_confirm_popup_button_click: (isDelete: boolean) => ({
    schema: 'iglu:com.psp/cashier_payout_account_delete_confirm_popup_button_click/jsonschema/1-0-0',
    data: {
      delete_confirmed: isDelete,
    },
  }),
  cashier_payout_continue_button_click: {
    schema: 'iglu:com.psp/cashier_payout_continue_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_payout_verification_page_open: {
    schema: 'iglu:com.psp/cashier_payout_verification_page_open/jsonschema/1-0-0',
    data: {},
  },
  cashier_payout_change_confirmation_contact_option_click: (contact: string) => ({
    schema: 'iglu:com.psp/cashier_payout_change_confirmation_contact_option_click/jsonschema/1-0-0',
    data: {
      contact,
    },
  }),
  cashier_payout_contact_support_option_click: {
    schema: 'iglu:com.psp/cashier_payout_contact_support_option_click/jsonschema/1-0-0',
    data: {},
  },
  cashier_payout_otp_request_button_click: (attempt: number) => ({
    schema: 'iglu:com.psp/cashier_payout_otp_request_button_click/jsonschema/1-0-0',
    data: {
      attempt,
    },
  }),
  cashier_payout_otp_confirm_button_click: (attempt: number) => ({
    schema: 'iglu:com.psp/cashier_payout_otp_confirm_button_click/jsonschema/1-0-0',
    data: {
      attempt,
    },
  }),
  cashier_payout_account_verification_result: {
    schema: 'iglu:com.psp/cashier_payout_account_verification_result/jsonschema/1-0-0',
    data: {
      verification_result_status_success: true,
    },
  },
  cashier_payout_verification_via_support_message_view: {
    schema: 'iglu:com.psp/cashier_payout_verification_via_support_message_view/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_redirect_link_click: {
    schema: 'iglu:com.psp/cashier_method_redirect_link_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_method_redirect_page_open: {
    schema: 'iglu:com.psp/cashier_method_redirect_page_open/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  pw_method_redirect_page_open_result: (result: boolean | null = null) => ({
    schema: 'iglu:com.psp/pw_method_redirect_page_open_result/jsonschema/1-0-0',
    data: {
      is_success: result,
    },
  }),
  cashier_payout_back_button_click: {
    schema: 'iglu:com.psp/cashier_payout_back_button_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  cashier_result_page_intogame_redirect: (status: string, destination: string) => ({
    schema: 'iglu:com.psp/cashier_result_page_intogame_redirect/jsonschema/1-0-0',
    data: {
      order_result_status: status,
      destination_page: destination,
    },
  }),
  demetr_carousel_view: {
    schema: 'iglu:com.psp/demetr_carousel_view/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  demetr_carousel_method_click: (method: string) => ({
    schema: 'iglu:com.psp/demetr_carousel_method_click/jsonschema/1-0-0',
    data: {
      method,
    },
  }),
  demetr_carousel_all_methods_click: {
    schema: 'iglu:com.psp/demetr_carousel_all_methods_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  demetr_carousel_submit_click: {
    schema: 'iglu:com.psp/demetr_carousel_submit_click/jsonschema/2-0-0',
    data: {
      is_event: true,
    },
  },
  pw_amount_change: ({
    initialAmount,
    enteredAmount,
    sessionId,
  }: {
    initialAmount?: number;
    enteredAmount?: number;
    sessionId: string;
  }) => ({
    schema: 'iglu:com.psp/pw_amount_change/jsonschema/1-0-0',
    data: {
      initial_amount: initialAmount || null,
      entered_amount: enteredAmount,
      session_id: sessionId,
    },
  }),
  pw_amount_input_click: ({ currentAmount, sessionId }: { currentAmount: number; sessionId: string }) => ({
    schema: 'iglu:com.psp/pw_amount_input_click/jsonschema/1-0-0',
    data: {
      current_amount: currentAmount,
      session_id: sessionId,
    },
  }),
  pw_get_otp_button: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_get_otp_button/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  pw_session_initiated: {
    schema: 'iglu:com.psp/pw_session_initiated/jsonschema/2-0-0',
    data: {
      is_pw_session_initiated: true,
    },
  },
  pw_display_form_open: {
    schema: 'iglu:com.psp/pw_display_form_open/jsonschema/2-0-0',
    data: {
      is_pw_display_form_open: true,
    },
  },
  pw_display_form_qr_copy: {
    schema: 'iglu:com.psp/pw_display_form_qr_copy/jsonschema/2-0-0',
    data: {
      is_pw_display_form_qr_copy: true,
    },
  },
  pw_display_form_qr_download: {
    schema: 'iglu:com.psp/pw_display_form_qr_download/jsonschema/2-0-0',
    data: {
      is_pw_display_form_qr_download: true,
    },
  },
  pw_display_form_input_copy: {
    schema: 'iglu:com.psp/pw_display_form_input_copy/jsonschema/2-0-0',
    data: {
      is_pw_display_form_input_copy: true,
    },
  },
  pw_display_form_button_made_payment: {
    schema: 'iglu:com.psp/pw_display_form_button_made_payment/jsonschema/2-0-0',
    data: {
      is_pw_display_form_button_made_payment: true,
    },
  },
  pw_category_click: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_category_click/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  growthbook_experiment_start: ({
    key,
    variationId,
    sessionId,
  }: {
    key: string;
    variationId: number;
    sessionId: string;
  }) => ({
    schema: 'iglu:com.psp/growthbook_experiment_start/jsonschema/2-0-0',
    data: {
      experiment_key: key,
      experiment_variant_id: variationId,
      session_id: sessionId,
    },
  }),
  pw_currency_type_click: ({ sessionId, type }: { sessionId: string; type: string }) => ({
    schema: 'iglu:com.psp/pw_currency_type_click/jsonschema/2-0-0',
    data: {
      session_id: sessionId,
      type,
    },
  }),
  pw_currency_click: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_currency_click/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  pw_currency_change: ({ sessionId, currency }: { sessionId: string; currency: string }) => ({
    schema: 'iglu:com.psp/pw_currency_change/jsonschema/2-0-0',
    data: {
      session_id: sessionId,
      currency,
    },
  }),
  pw_currency_search: ({ search_query }: { search_query: string }) => ({
    schema: 'iglu:com.psp/pw_currency_search/jsonschema/1-0-0',
    data: {
      search_query,
    },
  }),
  pw_network_click: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_network_click/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  pw_bonus_list_click: ({ numberOfBonuses }: { numberOfBonuses: number }) => ({
    schema: 'iglu:com.psp/pw_bonus_list_click/jsonschema/1-0-0',
    data: {
      number_of_bonuses: numberOfBonuses,
    },
  }),
  pw_bonus_click: ({ promotionId, bonusName }: { promotionId: string | null; bonusName: string | null }) => ({
    schema: 'iglu:com.psp/pw_bonus_click/jsonschema/2-0-0',
    data: {
      promotion_id: promotionId,
      bonus_name: bonusName,
    },
  }),
  pw_amount_decrease_click: (amountValue: number | null) => ({
    schema: 'iglu:com.psp/pw_amount_decrease_click/jsonschema/1-0-0',
    data: {
      amount_value: amountValue,
    },
  }),
  pw_amount_increase_click: (amountValue: number | null) => ({
    schema: 'iglu:com.psp/pw_amount_increase_click/jsonschema/1-0-0',
    data: {
      amount_value: amountValue,
    },
  }),
  pw_session_expired_modal_open: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_session_expired_modal_open/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  pw_session_expired_refresh_click: (sessionId: string) => ({
    schema: 'iglu:com.psp/pw_session_expired_refresh_click/jsonschema/1-0-0',
    data: {
      session_id: sessionId,
    },
  }),
  pw_bonus_details_click: ({ promotionId, bonusName }: { promotionId: string | null; bonusName: string | null }) => ({
    schema: 'iglu:com.psp/pw_bonus_details_click/jsonschema/1-0-0',
    data: {
      promotion_id: promotionId,
      bonus_name: bonusName,
    },
  }),
  pw_bonus_gotit_click: ({ promotionId, bonusName }: { promotionId: string | null; bonusName: string | null }) => ({
    schema: 'iglu:com.psp/pw_bonus_gotit_click/jsonschema/1-0-0',
    data: {
      promotion_id: promotionId,
      bonus_name: bonusName,
    },
  }),
};
